// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"0b52e078","455":"c986ca82","977":"79896481"}[chunkId] + ".chunk.js";
};